import React from "react";
import { Link } from "react-router-dom";

export default function WhyChooseUs2() {
  const ChartComponent = () => (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        display: "flex",
        alignItems: "flex-end",
        gap: "8px",
        zIndex: 2,
      }}
    >
      {[30, 45, 60, 75, 90, 105].map((height, i) => (
        <div
          key={i}
          style={{
            width: "20px",
            height: `${height}px`,
            backgroundColor: [
              "#87CEEB",
              "#FFB6C1",
              "#9370DB",
              "#40E0D0",
              "#FFD700",
              "#FF4500",
            ][i],
            borderRadius: "3px 3px 0 0",
          }}
        ></div>
      ))}
    </div>
  );

  const cards = [
    {
      title: "Vendor-agnostic",
     
      image: require("../../assets/images/IT_Consulting_Images/vendor-agnostic.jpg"),
    },
    {
      title: "Expert Team",
      
      image: require("../../assets/images/IT_Consulting_Images/collabrative-culture.jpg"),
    },
    {
      title: "24/7 Support",
    
      //image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=300&fit=crop",
      image: require("../../assets/images/IT_Consulting_Images/continous-improvement.jpg"),
    },
    {
      title: "Scalable solutions",
     
      //image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop",
      image: require("../../assets/images/IT_Consulting_Images/scalable-solution.jpg"),
      hasChart: true,
    },
    {
      title: "Cost Effective",
      
      //image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&h=300&fit=crop",
      image: require("../../assets/images/IT_Consulting_Images/cost-effective-solutions.jpg"),
    },
    {
      title: "Innovation Focus",
      
      //image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400&h=300&fit=crop",
      image: require("../../assets/images/IT_Consulting_Images/innovation-focus.jpg"),
    },
    {
      title: "Data Security",
     
      //image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=400&h=300&fit=crop",
      image: require("../../assets/images/IT_Consulting_Images/data-security.jpg"),
    },
    {
      title: "Global Reach",
      
      //image: "https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=400&h=300&fit=crop",
      image: require("../../assets/images/IT_Consulting_Images/data-driven-decision.jpg"),
    },
  ];

  return (
    <div className="container-fluid py-5" style={{ minHeight: "100vh" }}>
      <div className="container">
        {/* Header */}
        <div className="row justify-content-center mb-5">
          <div className="col-lg-10 text-center">
            <h1
              className="display-4 mb-4 text-danger fw-bold"
              style={{ fontSize: "clamp(2rem, 5vw, 3.5rem)" }}
            >
              Why Choose Starparth: Your IT Consulting Partner?
            </h1>
          </div>
        </div>

        {/* Cards Grid */}
        <div className="row g-4">
          {cards.map((card, index) => (
            <div key={index} className="col-lg-3 col-md-6 col-sm-6"
               data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"            
            >
              <div
                className="card h-100 border-0 shadow-sm"
                style={{
                  cursor: "pointer",
                  overflow: "hidden",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 25px rgba(0,0,0,0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "";
                }}
              >
                <div
                  style={{
                    position: "relative",
                    height: "200px",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-100 h-100"
                    style={{ objectFit: "cover" }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      background:
                        "linear-gradient(45deg, rgba(155, 89, 182, 0.85), rgba(142, 68, 173, 0.85), rgba(125, 60, 152, 0.85))",
                      backgroundImage:
                        "radial-gradient(circle at 20% 80%, rgba(255,255,255,0.1) 2px, transparent 2px), radial-gradient(circle at 80% 20%, rgba(255,255,255,0.1) 2px, transparent 2px), radial-gradient(circle at 40% 40%, rgba(255,255,255,0.05) 1px, transparent 1px)",
                      backgroundSize: "50px 50px, 60px 60px, 30px 30px",
                    }}
                  ></div>
                 
                 
                </div>
                <div className="card-body text-center p-4">
                  <h5
                    className="card-title mb-2 fw-semibold text-dark"
                    style={{ fontSize: "clamp(0.9rem, 2vw, 1.1rem)" }}
                  >
                    {card.title}
                  </h5>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="row justify-content-center mt-5">
          <div className="col-lg-8 text-center">
            <div
              className="p-4 rounded-3"
              style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "white",
              }}
            >
              <h3 className="mb-3 text-white">
                Ready to Transform Your Business?
              </h3>
              <p className="mb-4 text-white">
                Let's discuss how our company expertise can drive your
                success.
              </p>
              <Link
                to="/contact"
                className="btn btn-light btn-lg px-5 fw-semibold rounded-pill"
                style={{ transition: "transform 0.3s ease" }}
                onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
              >
                Get Started Today
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
